import { __ } from '@wordpress/i18n';
import { useBlockProps, MediaUpload, MediaUploadCheck, InspectorControls, InnerBlocks, ColorPalette } from '@wordpress/block-editor';
import { PanelBody, Button, SelectControl, IconButton } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import './style.css';

const Edit = ({ attributes, setAttributes, clientId }) => {
    const { imageUrl, backgroundColor, position, imagePosition } = attributes;

    const parentClientId = useSelect(
        (select) => select('core/block-editor').getBlockRootClientId(clientId),
        [clientId]
    );

    const parentAttributes = useSelect(
        (select) => parentClientId ? select('core/block-editor').getBlockAttributes(parentClientId) : {},
        [parentClientId]
    );

    const { height } = parentAttributes;

    const blockProps = useBlockProps({
        className: 'custom-slide',
        style: { height: height ? `${height}px` : 'auto' },
    });

    const onSelectImage = (media) => {
        setAttributes({ imageUrl: media.url });
    };

    const TEMPLATE = [
        ['core/heading', {
            placeholder: __('Enter heading...', 'custom'),
            style: {
                typography: {
                    fontSize: '5rem',
                },
                spacing: {
                    margin: '0',
                    padding: '0',
                },
            },
        }],
        ['core/paragraph', { placeholder: __('Enter description...', 'custom') }],
    ];

    return (
        <div {...blockProps}>
            <InspectorControls>
                <PanelBody title={__('Settings', 'custom')}>
                    <p>{__('Select Background Color', 'custom')}</p>
                    <ColorPalette
                        value={backgroundColor}
                        onChange={(color) => setAttributes({ backgroundColor: color })}
                    />
                    <SelectControl
                        label={__('Text Position', 'custom')}
                        value={position}
                        options={[
                            { label: __('Left', 'custom'), value: 'left' },
                            { label: __('Middle', 'custom'), value: 'middle' },
                            { label: __('Right', 'custom'), value: 'right' },
                        ]}
                        onChange={(newPosition) => setAttributes({ position: newPosition })}
                    />
                    <SelectControl
                        label={__('Image Position', 'custom')}
                        value={imagePosition}
                        options={[
                            { label: __('Left', 'custom'), value: 'image-left' },
                            { label: __('Right', 'custom'), value: 'image-right' },
                            { label: __('Full Width', 'custom'), value: 'image-full-width' },
                        ]}
                        onChange={(newImagePosition) => {
                            setAttributes({ imagePosition: newImagePosition });
                        }}
                    />
                </PanelBody>
            </InspectorControls>
            <div className={`slide-preview ${imagePosition !== 'image-right' ? imagePosition : ''}`} style={{ backgroundColor }}>
                <MediaUploadCheck>
                    <MediaUpload
                        onSelect={onSelectImage}
                        allowedTypes={['image']}
                        render={({ open }) => (
                            <>
                                {imageUrl ? (
                                    <div className="image-edit">
                                        <img src={imageUrl} alt={__('Selected image', 'custom')} />
                                        <IconButton
                                            icon="edit"
                                            label={__('Remove/Replace image', 'custom')}
                                            onClick={open}
                                            style={{ position: 'absolute', top: 0, left: 0 }}
                                        >
                                            {__('Remove/Replace image', 'custom')}
                                        </IconButton>
                                    </div>
                                ) : (
                                    <Button onClick={open}>
                                        {__('Select Image', 'custom')}
                                    </Button>
                                )}
                            </>
                        )}
                    />
                </MediaUploadCheck>
                <div className="wrapper-group">
                    <div className={`inner-group ${position}`} style={{ width: '55%' }}>
                        <InnerBlocks
                            template={TEMPLATE}
                            templateLock={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Edit;
